import { IState } from '../../store';

export function verifiedByCianSelector(state: IState): boolean {
  return state.offerData.offer.isVerifiedByCian || false;
}
